import { render, staticRenderFns } from "./TeamDialog.vue?vue&type=template&id=32c13d14&scoped=true"
import script from "./TeamDialog.vue?vue&type=script&lang=js"
export * from "./TeamDialog.vue?vue&type=script&lang=js"
import style0 from "./TeamDialog.vue?vue&type=style&index=0&id=32c13d14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c13d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c13d14')) {
      api.createRecord('32c13d14', component.options)
    } else {
      api.reload('32c13d14', component.options)
    }
    module.hot.accept("./TeamDialog.vue?vue&type=template&id=32c13d14&scoped=true", function () {
      api.rerender('32c13d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invention/TeamDialog.vue"
export default component.exports